module.exports = __webpack_public_path__ + "static/media/rapidpass.7995c005.svg";